/* tslint:disable */
/* eslint-disable */

/**
 * The practice type of the compensation data.
 */
export enum PracticeType {
  Academic = 'Academic',
  Hospital = 'Hospital',
  PrivatePractice = 'PrivatePractice',
  Government = 'Government',
  Other = 'Other'
}
